import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { toggleUpdateNotificationModal } from '../../actions/updateNotificationActions';
import { IinitialState } from '../../reducers';

interface IdispatchProps {
    showUpdateNotificationModal: boolean;
    toggleUpdateNotificationModal: typeof toggleUpdateNotificationModal;
}

class UpdateNotificationModal extends React.Component<
    IdispatchProps & WithTranslation
> {
    handleClose = () => {
        this.props.toggleUpdateNotificationModal();
    };

    render() {
        return (
            <Modal
                container={document.querySelector('.app')}
                className="update-notification-modal"
                bsSize="large"
                show={this.props.showUpdateNotificationModal}
                onHide={this.handleClose}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>We've Made Some Updates</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="update-notification-content">
                        <p>
                            We've updated several areas of the website and will
                            continue to improve it. We hope these changes make
                            the experience easier and provide more useful
                            information for you and your facility.
                        </p>
                        <p>
                            Your feedback helps — email{' '}
                            <a href="mailto:Mymedgas.support@beaconmedaes.com">
                                Mymedgas.support@beaconmedaes.com
                            </a>{' '}
                            with any thoughts, suggestions, or questions.
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="primary" onClick={this.handleClose}>
                        Got It
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

const mapStateToProps = (state: IinitialState) => {
    return {
        showUpdateNotificationModal: state.showUpdateNotificationModal
    };
};

export default withTranslation('')(
    connect(mapStateToProps, {
        toggleUpdateNotificationModal
    })(UpdateNotificationModal)
);
